export class ServerError extends Error {
  constructor(message = '500', eventId) {
    super(message)
    this.name = 'serverError'
    this.status = 500
    this.eventId = eventId
    this.report = false
  }
}
